import { useDetailApi } from "../../../swr/useApi";
import { partnersService } from "../../api_client";
import type { PartnerDto } from "../../../api";

export function usePartnerDetails(id: number) {
    return useDetailApi<PartnerDto>({
        key: `partner-details-${id}`,
        serviceMethod: async () => await partnersService.getPartner(id),
    });
}

